<template>
  <div>
    <div class="panel-question">
      
      <h6>Question / issue</h6>
      <a-form-item class="mb-5">
        <a-textarea
          v-model="formComment.message"
          placeholder="Add more question ..."
          :rows="4"
        />
      </a-form-item>
      <a-form :layout="'horizontal'">
        <a-form-item
          class="mb-5"
          label="Attachments (if any)"
          :label-col="{ span: 7 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-upload
            :file-list="fileList"
            :remove="handleRemove"
            :before-upload="beforeUpload"
            :multiple="false"
            v-model="formComment.upload_file"
            extra="*** Screen-shot of issue (showing the Problemm, disconnects or failed connections, etc.)"
          >
            <a-button> <a-icon type="upload" /> Upload </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
      <a-button
        v-if="!btnloadingWait"
        @click="submitComment"
        class="mt-10"
        type="primary"
      >
        Submit
      </a-button>
      <p v-else class="mt-10 mb-10"><a-spin class="mr-5" />Loading...</p>
    </div>
  </div>
</template>

<script>
const formMore = {
  message: "",
  upload_file: null,
};
export default {
  props: {
    dataWait: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formComment: Object.assign({}, formMore),
      // file upload
      fileList: [],
      uploading: false,
      errorFile: "",
      // loading
      btnloadingWait: false,
    };
  },
  methods: {
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      this.formComment.upload_file = file;
      this.fileList = [...this.fileList, file];
      return false;
    },
    async submitComment() {
      this.btnloadingWait = true;
      try {
        const sendMsgComment = new FormData();
        sendMsgComment.append("msg_type", 'ask');
        sendMsgComment.append("message", ![null,'null',''].includes(this.formComment.message) ? this.formComment.message : 'More document example ...');
        if (this.formComment.upload_file !== null) {
          sendMsgComment.append("upload_file", this.formComment.upload_file);
        } else {
          sendMsgComment.append("upload_file", null);
        }
        const resCreateMsg = await this.$http.post(
          `/ticket/msg/push/${this.dataWait.id}/`,
          sendMsgComment,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (resCreateMsg.status === 201) {
          this.$emit("addNewComment", resCreateMsg.data);
          this.formComment = Object.assign({}, formMore);
          this.handleRemove(this.formComment.upload_file) 
          this.btnloadingWait = false;
        }
      } catch (error) {
        this.btnloadingWait = false;
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /ticket/msg/push/${this.dataWait.id}/`,
        });
      }
    },
  },
};
</script>

<style scoped>
.panel-question {
  background: #fafafa;
  padding: 20px;
  border-radius: 10px;
}
</style>